import PropTypes from 'prop-types';
import React from 'react';

import {ActionOrigin} from 'constants/AnalyticsConstants';
import * as SampleConstants from 'constants/SampleConstants';
import {StorableWithPermissions} from 'constants/SampleConstants';
import {ButtonStyle} from 'ui-library/buttons/Button';

import StorableToolbarContents from './StorableToolbarContents';

interface Props {
  isLoading: boolean;
  storables: Array<StorableWithPermissions> | null;
  selectedIds: Array<string>;
}

export default function StorableToolbar({isLoading, storables, selectedIds}: Props): JSX.Element {
  return (
    <div className="buttonToolbar">
      <StorableToolbarContents
        actionOrigin={ActionOrigin.INVENTORY_EXPANDED_SEARCH_TOOLBAR}
        buttonStyle={ButtonStyle.TERTIARY_WHITE}
        isLoading={isLoading}
        storables={storables}
        selectedIds={selectedIds}
      />
    </div>
  );
}

StorableToolbar.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  storables: PropTypes.arrayOf(SampleConstants.STORABLE_SUMMARY_SHAPE),
  selectedIds: PropTypes.array.isRequired,
};
